export const set_redirectToValidateOrFinish = (redirectToValidateOrFinish) => ({ type: "SET_REDIRECT", redirectToValidateOrFinish: redirectToValidateOrFinish })
export const set_url_for_finish = (url) => ({ type: "SET_URL", url: url })
export const set_modal = (modal) => ({ type: "SET_MODAL", modal: modal })
export const set_isValid = (isValid) => ({ type: "SET_ISVALID", isValid: isValid })





// WEBPACK FOOTER //
// src/actions/stepTwoActions.js